import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";

const TARGET_TYPE_OPTIONS = [
  { value: "", label: "ທັງໝົດ" },
  { value: "listing", label: "ລາຍການສິນຄ້າ" },
  { value: "review", label: "ຄຳແນະນຳ" },
  { value: "shop", label: "ຮ້ານຄ້າ" },
  { value: "mechanic", label: "ຊ່າງແປງ" },
  { value: "job", label: "ວຽກ" },
];

export type HistorySearchParams = {
  limit?: number;
  offset?: number;
  fromDate?: string;
  toDate?: string;
  targetType?: string;
};

export function ModerationHistoryFilter() {
  const navigate = useNavigate({ from: "/app/moderation/history" });
  const search = useSearch({
    from: "/app/moderation/history",
  }) as HistorySearchParams;

  const fromDate = search.fromDate ?? "";
  const toDate = search.toDate ?? "";
  const targetType = search.targetType ?? "";

  const setSearch = (updates: Partial<HistorySearchParams>) => {
    navigate({
      search: {
        ...search,
        ...updates,
        offset: updates.offset ?? 0,
      },
    });
  };

  const clearFilters = () => {
    navigate({
      search: {
        ...search,
        fromDate: undefined,
        toDate: undefined,
        targetType: undefined,
        offset: 0,
      },
    });
  };

  const hasFilters = fromDate || toDate || targetType;

  return (
    <div className="flex flex-wrap items-end gap-3 border-b px-4 pb-3">
      <div className="flex flex-col gap-1">
        <label
          htmlFor="history-from-date"
          className="text-muted-foreground text-xs"
        >
          ຈາກວັນທີ
        </label>
        <input
          id="history-from-date"
          type="date"
          value={fromDate}
          onChange={(e) =>
            setSearch({ fromDate: e.target.value || undefined, offset: 0 })
          }
          className="rounded-md border bg-background px-2 py-1.5 text-sm"
        />
      </div>
      <div className="flex flex-col gap-1">
        <label
          htmlFor="history-to-date"
          className="text-muted-foreground text-xs"
        >
          ເຖິງວັນທີ
        </label>
        <input
          id="history-to-date"
          type="date"
          value={toDate}
          onChange={(e) =>
            setSearch({ toDate: e.target.value || undefined, offset: 0 })
          }
          className="rounded-md border bg-background px-2 py-1.5 text-sm"
        />
      </div>
      <Select
        value={targetType || "all"}
        onValueChange={(v) =>
          setSearch({ targetType: v === "all" ? undefined : v, offset: 0 })
        }
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="ປະເພດເປົ້າໝາຍ" />
        </SelectTrigger>
        <SelectContent>
          {TARGET_TYPE_OPTIONS.map((o) => (
            <SelectItem key={o.value || "all"} value={o.value || "all"}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {hasFilters && (
        <Button variant="ghost" size="sm" onClick={clearFilters}>
          ລ້າງຕົວກອງ
        </Button>
      )}
    </div>
  );
}
